(() => {
  if (window.FOHOrderLookupEmbedInit) return;
  window.FOHOrderLookupEmbedInit = true;

  const TRUSTED_ORIGIN = 'https://dont-panic.fallouthobbies.workers.dev';

  window.addEventListener('message', (event) => {
    if (event.origin !== TRUSTED_ORIGIN) return;
    if (!event.data || event.data.type !== 'foh-order-lookup-height') return;

    const rawHeight = Number(event.data.height);
    if (!Number.isFinite(rawHeight) || rawHeight <= 0) return;

    const height = Math.max(160, Math.min(Math.ceil(rawHeight), 1400));
    const iframes = document.querySelectorAll('[data-foh-order-lookup-iframe]');

    iframes.forEach((iframe) => {
      try {
        if (iframe.contentWindow && event.source && iframe.contentWindow !== event.source) return;
      } catch (error) {
        return;
      }

      iframe.style.height = `${height}px`;
      iframe.setAttribute('height', String(height));
    });
  });
})();
